import { IDeleteMaquinasEquipItensUseCase } from "../../../presentation/useCases/delete/delete_maquinas_equip_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteMaquinasEquipItensUseCase
 */

export class DeleteMaquinasEquipItensUseCase implements IDeleteMaquinasEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteMaquinasEquipItens(
    idMaquinaEquip: number,
    idItemMaquinaEquip: number,
  ): Promise<void> {
    await this.repository.deleteControledePatrimonioMaquinasEquipItens(idItemMaquinaEquip, idMaquinaEquip);
  }
}
